import React from 'react';
import {
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
} from '@tempo/core';
import {useTranslation} from 'next-i18next';

type DeleteConnectedAccountsModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onDelete: () => void;
};

const DeleteConnectedAccountsModal = ({
	isOpen,
	onClose,
	onDelete,
}: DeleteConnectedAccountsModalProps) => {
	const {t} = useTranslation('d4c');
	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>{t('usermanager_title_unlinkuser_d4c-web')}</ModalHeader>
				<ModalCloseButton border="none" boxSizing="border-box" />
				<ModalBody>
					<Text
						color="text.neutral.secondary.default"
						variant="body.default.regular"
					>
						{t('usermanager_text_suretounlinkuserfromaccount_d4c-web')}
					</Text>
				</ModalBody>

				<ModalFooter>
					<Button onClick={onClose} variant="ghost">
						{t('generic_action_cancel_d4c-web')}
					</Button>
					<Button onClick={onDelete}>
						{t('profilesettings_action_unlink_d4c-web')}
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default DeleteConnectedAccountsModal;
